// client/src/components/TypingDots.js
// Presentation-only bouncing 3-dot "assistant is typing" indicator.
// Pure JSX: it reads no state, writes nothing, and never touches `turns`.
// Shared by the left pane (real streaming bubble + temporary pending
// placeholder) and the right pane (suggestion/report streaming).
import { Box, Flex } from "@chakra-ui/react";

export default function TypingDots({ mt = "8px" }) {
    return (
        <Flex mt={mt} color="gray.400" fontSize="12px" gap="4px" aria-label="Assistant is typing">
            <Box as="span" display="inline-block" animation="bounce 1s infinite">
                •
            </Box>
            <Box
                as="span"
                display="inline-block"
                animation="bounce 1s infinite"
                style={{ animationDelay: '0.1s' }}
            >
                •
            </Box>
            <Box
                as="span"
                display="inline-block"
                animation="bounce 1s infinite"
                style={{ animationDelay: '0.2s' }}
            >
                •
            </Box>
        </Flex>
    );
}
